import { Link, useParams } from "react-router-dom";
import { Logo } from "@/components/Logo";

const DOCS = {
  termos: {
    title: "Termos de uso",
    body: [
      "A TRADE REPUBLIC é, nesta versão, uma plataforma em MODO DEMONSTRAÇÃO. Os saldos são virtuais e nenhuma ordem é enviada a corretoras, bolsas ou intermediários reais.",
      "As contas são criadas exclusivamente pela equipe administrativa. O cliente é responsável por manter a confidencialidade de suas credenciais e por ativar a autenticação em dois fatores.",
      "Cotações de criptomoedas são obtidas de fontes públicas e identificadas como AO VIVO. Demais cotações são SIMULADAS e identificadas como tal; não devem ser usadas para decisões reais.",
      "Operações alavancadas envolvem alto risco. Resultados passados não garantem resultados futuros.",
      "Contas podem ser suspensas ou encerradas conforme regras de compliance, prevenção à fraude e legislação aplicável.",
    ],
  },
  privacidade: {
    title: "Política de privacidade",
    body: [
      "Tratamos dados pessoais (nome, e-mail, telefone, documentos e registros de acesso) com base na LGPD (Lei 13.709/2018), para execução do contrato, segurança e cumprimento de obrigações legais.",
      "Senhas são armazenadas apenas em formato de hash (bcrypt). Nenhuma senha é armazenada no navegador; sessões usam cookies seguros httpOnly.",
      "Registramos IP, dispositivo e horário de acesso para segurança da conta. Você pode encerrar sessões a qualquer momento em Segurança.",
      "Você pode solicitar acesso, correção ou exclusão de dados ao nosso encarregado de proteção de dados: [e-mail do DPO].",
    ],
  },
  cookies: {
    title: "Política de cookies",
    body: [
      "Cookies estritamente necessários: access_token e refresh_token (httpOnly, seguros) para manter sua sessão autenticada.",
      "Preferências locais: tema, tamanho de fonte e modo iniciante ficam salvos no seu navegador.",
      "Cookies de análise e marketing são opcionais e só seriam ativados mediante consentimento. Você pode alterar sua escolha a qualquer momento no menu do usuário.",
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const d = DOCS[doc] || DOCS.termos;
  return (
    <div className="mx-auto max-w-3xl px-6 py-12">
      <Link to="/"><Logo /></Link>
      <h1 className="mt-10 text-3xl md:text-4xl font-bold tracking-tight" data-testid="legal-title">{d.title}</h1>
      <p className="mt-2 text-xs text-muted-foreground">Versão 2026-01 · Documento modelo — revise com assessoria jurídica antes de operar com clientes reais.</p>
      <div className="mt-8 space-y-5 text-base leading-relaxed">{d.body.map((p, i) => <p key={i}>{p}</p>)}</div>
      <div className="mt-10 flex gap-4 text-sm">
        {Object.entries(DOCS).map(([k, v]) => <Link key={k} to={`/legal/${k}`} className="text-primary hover:underline" data-testid={`legal-link-${k}`}>{v.title}</Link>)}
      </div>
    </div>
  );
}
